'use strict';

import React from 'react';
import { Link } from 'react-scroll';

require('styles//BackToTop.scss');

let BackToTopComponent = (props) => (
  <div className="back-to-top" id="button-back-to-top">
    <Link to="top" smooth={true} duration={400}><img id="image-back-to-top" src="../images/arrow.png"></img>
    </Link>
  </div>

);

BackToTopComponent.displayName = 'BackToTopComponent';

// Uncomment properties you need
// BackToTopComponent.propTypes = {};
// BackToTopComponent.defaultProps = {};

export default BackToTopComponent;



// WEBPACK FOOTER //
// ./src/components/BackToTopComponent.js